/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type PositionMetrics = {
  totalClaimedAFee: bigint;
  totalClaimedBFee: bigint;
};

export type PositionMetricsArgs = {
  totalClaimedAFee: number | bigint;
  totalClaimedBFee: number | bigint;
};

export function getPositionMetricsEncoder(): FixedSizeEncoder<PositionMetricsArgs> {
  return getStructEncoder([
    ["totalClaimedAFee", getU64Encoder()],
    ["totalClaimedBFee", getU64Encoder()],
  ]);
}

export function getPositionMetricsDecoder(): FixedSizeDecoder<PositionMetrics> {
  return getStructDecoder([
    ["totalClaimedAFee", getU64Decoder()],
    ["totalClaimedBFee", getU64Decoder()],
  ]);
}

export function getPositionMetricsCodec(): FixedSizeCodec<
  PositionMetricsArgs,
  PositionMetrics
> {
  return combineCodec(getPositionMetricsEncoder(), getPositionMetricsDecoder());
}
